// Os quatro prazos publicados na cotação, na ordem em que aparecem na tela e no app.
// Espelha App\Models\ExchangeRate::TERMS no backend — mexeu aqui, mexa lá.
const TERM_FIELDS = [
  "rate_cash",
  "rate_check_30",
  "rate_check_60",
  "rate_check_90",
];

const TERM_LABELS = {
  rate_cash: "Câmbio dia",
  rate_check_30: "Cheque 30 dias",
  rate_check_60: "Cheque 60 dias",
  rate_check_90: "Cheque 90 dias",
};

// Formata a taxa para leitura (pt-BR, até 6 casas — guarani usa poucas, pares
// fracionários usam mais). Vazio vira "—".
function formatRate(value) {
  if (value === null || value === undefined || value === "") return "—";
  const parsed = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(parsed)) return "—";
  return parsed.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  });
}

// "2026-08-09" -> "09/08/2026". Corta a string em vez de usar new Date() para não
// deslocar o dia por fuso (a data da cotação é um dia civil, não um instante).
function formatDate(value) {
  if (!value) return "—";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  return day && month && year ? `${day}/${month}/${year}` : String(value);
}

export { TERM_FIELDS, TERM_LABELS, formatRate, formatDate };
